var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userId
    ? _c("div", { staticClass: "ui dropdown profileMenu" }, [
        _c("a", { staticClass: "profileMenu__userMenuIcon" }, [
          _c("i", { staticClass: "fas fa-user-circle" }),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$root.unreadNotifications.length > 0,
                expression: "$root.unreadNotifications.length > 0",
              },
            ],
            staticClass: "profileMenu__userMenuBadge",
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "left large menu" }, [
          _c("a", { staticClass: "item", attrs: { href: "/notifications" } }, [
            _vm._v("通知"),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$root.unreadNotifications.length > 0,
                    expression: "$root.unreadNotifications.length > 0",
                  },
                ],
                staticClass:
                  "ui red circular label profileMenu__notificationBadge",
              },
              [_vm._v(_vm._s(_vm.$root.unreadNotifications.length))]
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "item", attrs: { href: "/member/settings" } },
            [_vm._v("ユーザー情報変更")]
          ),
          _vm._v(" "),
          _c("a", { staticClass: "item", attrs: { href: "/chats" } }, [
            _vm._v("チャット一覧"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "divider" }),
          _vm._v(" "),
          _c("div", { staticClass: "item", on: { click: _vm.logout } }, [
            _vm._v("ログアウト"),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }